import { t } from "i18next";
import { faUserRobotXmarks } from "@fortawesome/pro-duotone-svg-icons";
import { H5 } from "@/components/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { tv } from "tailwind-variants";

interface IProps {
  message?: string;
  height?: string;
}

const styles = tv({
  slots: {
    container:
      "flex w-full flex-col items-center justify-center gap-50 text-center",
  },
});

const ComponentError = ({
  message = t("generic.error"),
  height = "h-[300px]",
}: IProps) => {
  const { container } = styles();

  return (
    <div
      className={container({ className: height })}
      data-testid="component-error">
      <FontAwesomeIcon
        icon={faUserRobotXmarks}
        className="h-75 text-secondary"
      />
      <H5 color="secondary">{message}</H5>
    </div>
  );
};
export default ComponentError;
